<template>
  <div class="ui form">
    <table class="ui very basic center aligned table">
      <thead>
        <tr>
          <th style="width: 45%">Choose from {{ visitDetailItem.item.name }} Invoice</th>
          <th style="width: 45%">Quantity From Invoice</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(invoiceForm, invoiceFormIndex) in invoicesForm"
          :key="invoiceForm.formEntryId"
        >
          <td>
            <div class="required field">
              <select
                class="ui dropdown selection selectClass"
                v-model="invoiceForm.invoiceId"
              >
                <option value="">Choose an Invoice</option>
                <option
                  v-for="invoiceEntry in visitDetailItem.invoice_entries"
                  :key="invoiceEntry.invoice_id"
                  :value="invoiceEntry.invoice_id"
                >
                  {{
                    `${invoiceEntry.label} Remaining: ${invoiceEntry.remaining}`
                  }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="required field">
              <div class="ui fluid required input">
                <input
                  type="number"
                  min="0.01"
                  step="0.01"
                  placeholder="Quantity from invoice"
                  v-model="invoiceForm.quantity"
                  :disabled="!invoiceForm.invoiceId"
                  :max="getMax(invoiceForm.invoiceId)"
                />
              </div>
            </div>
          </td>
          <td>
            <button
              type="button"
              class="ui icon button"
              @click="removeInvoiceEntry(invoiceFormIndex)"
            >
              <i class="minus circle icon"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="ui message errorMessage" v-if="errors.length">
      <p v-for="(error, errorIndex) in errors" :key="errorIndex">{{ error }}</p>
    </div>

    <button
      @click="addInvoiceEntry"
      type="button"
      class="ui primary button addVisitDetailInvoiceButton"
    >
      Add Another Invoice <i class="plus circle icon"></i>
    </button>
  </div>
</template>

<script>
import { nanoid } from 'nanoid';

export default {
  props: {
    entityType: { type: String, required: true },
    maxSum: { type: Number, required: true },
    itemIndex: { type: Number, required: true },
    visitDetailIndex: { type: Number, required: true },
    visitDetailItem: { type: Object, required: true },
    showErrors: { type: Boolean, required: true }
  },
  data() {
    return {
      index: this.itemIndex,
      item: this.visitDetailItem,
      errors: [],
      invoicesForm: [] // should be array of invoice entries + quantity
    };
  },
  mounted() {
    this.addInvoiceEntry();
  },
  watch: {
    invoicesForm: {
      handler: function() {
        this.$emit('onItemUpdate', {
          isValid: this.validateItemForm(),
          invoicesForm: this.invoicesForm,
          itemIndex: this.itemIndex,
          visitDetailIndex: this.visitDetailIndex
        });
      },
      deep: true
    }
  },
  methods: {
    initGUI() {
      this.$nextTick(() => {
        $('.selectClass').dropdown();
      });
    },
    validateItemForm() {
      this.errors = [];
      if (this.invoicesForm.length === 0) {
        this.errors.push('Error no invoice were chosen');
        return false;
      }
      let quantityError = false;
      let invoiceIdError = false;
      let duplicateInvoicesError = false;
      const validInvoiceEntriesCount = {};

      let totalQuantity = 0;
      this.invoicesForm.forEach(invoiceEntry => {
        // validate fields existance
        if (!invoiceEntry.quantity && !this.entityType === 'ItemCategory')
          quantityError = true;
        if (!invoiceEntry.invoiceId) invoiceIdError = true;

        if (invoiceEntry.quantity && parseInt(invoiceEntry.quantity))
          totalQuantity += parseInt(invoiceEntry.quantity);

        // validate max number of quantity
        if (validInvoiceEntriesCount[invoiceEntry.invoiceId] > 0) {
          duplicateInvoicesError = true;
        } else {
          validInvoiceEntriesCount[invoiceEntry.invoiceId] = true;
        }
      });

      if (this.entityType === 'Item' && totalQuantity != this.maxSum)
        this.errors.push(`Invoices quantities must sum to ${this.maxSum}`);

      if (quantityError) this.errors.push('Quantity error');
      if (invoiceIdError) this.errors.push('Invoice not selected');
      if (duplicateInvoicesError) this.errors.push('Duplicate Invoice');

      return this.errors.length === 0;
    },
    addInvoiceEntry() {
      this.invoicesForm.push(this.getInvoiceEntryObject());
      this.initGUI();
    },
    removeInvoiceEntry(index) {
      if (index === 0 && this.invoicesForm.length === 1) {
        this.invoicesForm = [this.getInvoiceEntryObject()];
      } else {
        this.invoicesForm.splice(index, 1);
      }
    },
    getMax(invoiceId) {
      if (this.entityType === 'Item') {
        return this.maxSum;
      }

      if (invoiceId && Array.isArray(this.visitDetailItem.invoice_entries)) {
        const chosenInvoiceEntry = this.visitDetailItem.invoice_entries.find(
          invoiceEntry => invoiceEntry.invoice_id === invoiceId
        );
        return chosenInvoiceEntry && chosenInvoiceEntry.remaining
          ? chosenInvoiceEntry.remaining
          : 0;
      }
      return 0;
    },
    getInvoiceEntryObject() {
      return {
        formEntryId: nanoid(),
        invoiceId: null,
        quantity: null
      };
    }
  }
};
</script>

<style>
.selectClass {
  width: 100%;
}
.errorMessage {
  color: red !important;
  font-size: 10px !important;
}
.addVisitDetailInvoiceButton {
  margin: 12px 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/visits/finalize-visits-components/VisitDetailItem.vue